import {html, body} from "./utils";

export class Hamburger {
    el: HTMLElement;


    constructor(el) {
        this.el = el
        this.el.addEventListener('click', this.toggle.bind(this))
        console.log('Hamburger::constructor')
    }

    toggle() {
        if (!this.el.classList.contains('open')) {
            html.classList.add('menu-open');
            body.classList.add('menu-open');
            this.el.classList.add('open');
        } else {
            html.classList.remove('menu-open');
            body.classList.remove('menu-open');
            this.el.classList.remove('open');
        }
    }
}
